import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SiteScan from '@/components/SiteScan';

// /scan: anyone, no login. "Can my site move to Hey Joe Sites?" ?url= prefills and
// runs it, so a result can be shared as a link.
const ScanPage: React.FC = () => {
  const [params] = useSearchParams();
  const initial = (params.get('url') || '').trim();
  return (
    <main className="mx-auto" style={{ maxWidth: 720, padding: '0 16px 96px', background: 'var(--hj-bg)', color: 'var(--hj-ink)', minHeight: 'calc(100vh - 68px)' }}>
      <header style={{ margin: '24px 0 20px', padding: '24px 24px 22px', borderRadius: 'var(--hj-r-md)', background: 'var(--hj-beige)', border: '1px solid var(--hj-beige-line)', color: 'var(--hj-beige-ink)' }}>
        <div className="mono-label" style={{ marginBottom: 10, color: 'var(--hj-beige-ink-2)' }}>Hey Joe Sites</div>
        <h1 className="font-hj-display m-0" style={{ fontSize: 'clamp(28px, 4.5vw, 40px)', lineHeight: 1.05, letterSpacing: '-0.02em', fontWeight: 800 }}>Can your site move to Hey Joe?</h1>
        <p style={{ margin: '12px 0 0', fontSize: 16, lineHeight: 1.5 }}>Actors pay $15 to $36 a month to a site builder for a page with a headshot, a reel and a contact form. Hosting that page is included with Hey Joe Plus. Scan yours and see.</p>
      </header>
      <section style={{ background: '#fff', border: '1px solid var(--hj-hairline-soft)', borderRadius: 16, padding: 24 }}>
        <SiteScan context="public" initialUrl={initial || undefined} autoRun={!!initial} />
      </section>
      <p style={{ fontSize: 13, color: 'var(--hj-ink-3)', margin: '16px 0 0' }}>We fetch the public home page once to look at it. Nothing is stored except the address and the result.</p>
    </main>
  );
};

export default ScanPage;
